var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Row, Col, AccordionSet, Accordion, ErrorModal, Modal, ModalFooter, } from "@folio/stripes/components";
import { useNewPublisherForm } from "../../hooks/useNewPublisherForm";
import { NewPublisherGeneralSection } from "./NewPublisherGeneralSection";
import { NewPublisherAddressSection } from "./NewPublisherAddressSection";
import { NewPublisherContactsSection } from "./NewPublisherContactsSection";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
var NewPublisherForm = function (_a) {
    var onPublisherCreated = _a.onPublisherCreated, onCancel = _a.onCancel, _b = _a.inModal, inModal = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useState({
        general: true,
        address: true,
        contacts: true,
    }), accordionStatus = _c[0], setAccordionStatus = _c[1];
    var _d = useState(true), expandAll = _d[0], setExpandAll = _d[1];
    var _e = useNewPublisherForm({ onPublisherCreated: onPublisherCreated, inModal: inModal }), publisherForm = _e.publisherForm, regionsData = _e.regionsData, icoError = _e.icoError, setIcoError = _e.setIcoError, trigger = _e.trigger, onSubmit = _e.onSubmit, blockingPublisher = _e.blockingPublisher, canSelectBlockingPublisher = _e.canSelectBlockingPublisher, dismissBlockingPublisher = _e.dismissBlockingPublisher, selectBlockingPublisher = _e.selectBlockingPublisher, resetForm = _e.resetForm, errorMessage = _e.errorMessage, dismissError = _e.dismissError, icoLoadedCallback = _e.icoLoadedCallback;
    var setValue = publisherForm.setValue, watch = publisherForm.watch, handleSubmit = publisherForm.handleSubmit, control = publisherForm.control, errors = publisherForm.formState.errors;
    var toggleExpandCollapseAll = function () {
        var newState = !expandAll;
        setAccordionStatus({
            general: newState,
            address: newState,
            contacts: newState,
        });
        setExpandAll(newState);
    };
    var handleCancel = function () {
        resetForm();
        dismissBlockingPublisher();
        dismissError();
        if (onCancel)
            onCancel();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
            React.createElement(ErrorModal, { open: errorMessage !== null, label: formatMessage({
                    id: "ui-br-legaldeposits.error.modal.title",
                }), content: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "", onClose: dismissError }),
            React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
            React.createElement(AccordionSet, null,
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-legaldeposits.publishers.accordion.general",
                    }), open: accordionStatus.general, onToggle: function () {
                        return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                    } },
                    React.createElement(NewPublisherGeneralSection, { control: control, errors: errors, icoError: icoError, setIcoError: setIcoError, trigger: trigger, setValue: setValue, watch: watch, icoLoadedCallback: icoLoadedCallback })),
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-legaldeposits.publishers.accordion.address",
                    }), open: accordionStatus.address, onToggle: function () {
                        return setAccordionStatus(__assign(__assign({}, accordionStatus), { address: !accordionStatus.address }));
                    } },
                    React.createElement(NewPublisherAddressSection, { control: control, errors: errors, regionsData: regionsData, setValue: setValue })),
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-legaldeposits.publishers.accordion.contacts",
                    }), open: accordionStatus.contacts, onToggle: function () {
                        return setAccordionStatus(__assign(__assign({}, accordionStatus), { contacts: !accordionStatus.contacts }));
                    } },
                    React.createElement(NewPublisherContactsSection, { control: control, errors: errors }))),
            React.createElement(Row, { between: "xs" },
                React.createElement(Col, { xs: 1 },
                    React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit(onSubmit) },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.save" }))),
                React.createElement(Col, { xs: 1 },
                    React.createElement(Button, { onClick: handleCancel },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))))),
        React.createElement(Modal, { open: blockingPublisher !== null, label: formatMessage({
                id: "ui-br-legaldeposits.publishers.modal.duplicateBlocked.heading",
            }), onClose: dismissBlockingPublisher, footer: React.createElement(ModalFooter, null,
                canSelectBlockingPublisher && (blockingPublisher === null || blockingPublisher === void 0 ? void 0 : blockingPublisher.publisherId) && (React.createElement(Button, { buttonStyle: "primary", onClick: selectBlockingPublisher }, formatMessage({
                    id: "ui-br-legaldeposits.publishers.modal.duplicateBlocked.selectExisting",
                }))),
                React.createElement(Button, { onClick: dismissBlockingPublisher }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
            React.createElement("p", null, (blockingPublisher === null || blockingPublisher === void 0 ? void 0 : blockingPublisher.publisherName)
                ? formatMessage({
                    id: "ui-br-legaldeposits.publishers.modal.duplicateBlocked.message",
                }, { publisher: blockingPublisher.publisherName })
                : formatMessage({
                    id: "ui-br-legaldeposits.publishers.modal.duplicateBlocked.messageWithoutName",
                })))));
};
NewPublisherForm.displayName = "NewPublisherForm";
export { NewPublisherForm };
